import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import Transfer247Form from '../../components/transfer/Transfer247Form';
import Storage from '../../services/Storage';

export default function Transfer247() {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (Storage.getLocalAccessToken() === null) {
      navigate('/signin', { replace: true })
    }
  }, [navigate])
  return (
    <Transfer247Form />
  );
}